import React from "react";
import { Grid, Skeleton, Box, Paper } from "@mui/material";

const StatisticsDashboardSkeleton = () => {
  return (
    <Box p={2}>
      {/* Chart Section Skeleton */}
      <Skeleton
        variant="rectangular"
        height={250}
        width="100%"
        sx={{ borderRadius: 2, mb: 4 }}
      />

      {/* Table Section Skeleton */}
      <Paper elevation={1} sx={{ p: 2 }}>
        <Grid container spacing={3}>
          {/* Header Row */}
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width="80%" height={30} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width="80%" height={30} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width="80%" height={30} />
          </Grid>

          {/* Table Rows */}
          {[...Array(5)].map((_, i) => (
            <React.Fragment key={i}>
              <Grid item xs={12} sm={4}>
                <Skeleton variant="text" width="90%" height={25} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Skeleton variant="text" width="80%" height={25} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Skeleton variant="text" width="70%" height={25} />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Paper>

    </Box>
  );
};

export default StatisticsDashboardSkeleton;
